// 跳转
export function _jump(url, _blank) {
  let newUrl = decodeBase64(url)
  // console.log(newUrl, 'newUrl')
  if (!_blank) {
    window.location = newUrl
  } else {
    window.open(newUrl, '_blank')
  }
}

// 加载图片
export function _load() {
  setInterval(() => {
    const images = document.querySelectorAll('.imgs')
    const h = window.innerHeight || document.documentElement.clientHeight
    const w = window.innerWidth || document.documentElement.clientWidth
    for (let i = 0; i < images.length; i++) {
      const img = images[i]
      const rect = img.getBoundingClientRect()
      if (
        rect.top + rect.height >= 0 &&
        rect.top <= h &&
        rect.left + rect.width >= 0 &&
        rect.left <= w
      ) {
        // 图片在可视范围内
        // console.log('图片在可视范围内:', imgs)
        img.className = img.className.replace('imgs', '')
        img.src = img.getAttribute('data-src')
        img.onload = () => {
          // img.className += ' img-ed'
        }
      }
    }
  }, 500)
}

// 设置localStorage
export function _localStorageSet(name, data) {
  var obj = {}
  obj.data = data
  obj.expire = new Date().getTime() + 1000 * 60 * 60 * 24 * 7
  localStorage.setItem(name, JSON.stringify(obj))
}

// 读取localStorage
export function _localStorageGet(name) {
  const storage = localStorage.getItem(name)
  const time = new Date().getTime()
  let result = null
  if (storage) {
    const obj = JSON.parse(storage)
    if (time < obj.expire) {
      result = obj.data
    } else {
      localStorage.removeItem(name)
    }
  }
  return result
}

// 文字base64转码uft8
export function _basetouft8() {
  var database64names = document.querySelectorAll('.base64name')
  // console.log(database64names)
  // IntersectionObserver to check if the image is in the viewport
  let observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        let database64name = entry.target
        let dataSrcValue = database64name.dataset.base64name
        const utf8String = decodeURIComponent(escape(window.atob(dataSrcValue)))
        database64name.textContent = utf8String
        observer.unobserve(database64name)
      }
    })
  })
  // Observe each lazy-loaded image
  database64names.forEach(function (database64name) {
    observer.observe(database64name)
  })
}

export function domLoad() {
  document.addEventListener('DOMContentLoaded', function () {
    const element1 = document.querySelector('.element1')
    const element2 = document.querySelector('.element2')

    function calculateDistance() {
      const rect1 = element1.getBoundingClientRect()
      const rect2 = element2.getBoundingClientRect()

      const distance = rect1.right - rect2.left

      // console.log(`距离：${distance}px`)
      // if (distance < 5) {
      //   console.log('sdfsfsdfsdafds')
      //   element2.style.transform = 'translateX(0)'
      // }

      return distance
    }

    function checkPosition() {
      console.log('345345')
      calculateDistance()
      requestAnimationFrame(checkPosition)
    }

    // 初始计算距离
    calculateDistance()

    // 使用requestAnimationFrame不断检查位置变化
    requestAnimationFrame(checkPosition)

    // 示例：2秒后还原transform

    // setTimeout(() => {
    //   element2.style.transform = 'translateX(0)'
    // }, 2000)
  })
}

export function isQQBrowser() {
  const userAgent = navigator.userAgent
  return userAgent.includes('MQQBrowser') || userAgent.includes('QQBrowser')
}

export function encodeBase64(str) {
  // console.log(str)
  return btoa(str)
}

export function decodeBase64(str) {
  return atob(str)
}

export const forEachUrlBase64 = (list) => {
  let newList = []
  if (list.length > 0) {
    list.forEach((item) => {
      item.url = encodeBase64(item.url)
      newList.push(item)
    })
  }
  return newList
}

//  pc横向滚动
export function pcScrollX() {
  const scrollContainer = document.querySelector('.scroll-container')

  let isDown = false
  let startX
  let scrollLeft

  scrollContainer.addEventListener('mousedown', (e) => {
    // console.log('123')
    isDown = true
    scrollContainer.classList.add('active')
    startX = e.pageX - scrollContainer.offsetLeft
    scrollLeft = scrollContainer.scrollLeft
  })

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false
    scrollContainer.classList.remove('active')
  })

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false
    scrollContainer.classList.remove('active')
  })

  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return // stop the function from running
    e.preventDefault()
    const x = e.pageX - scrollContainer.offsetLeft
    const walk = (x - startX) * 2 // scroll-fast
    scrollContainer.scrollLeft = scrollLeft - walk
  })
  // const scrollContainer = document.querySelector('.scroll-container');
  scrollContainer.addEventListener('wheel', function (e) {
    //   console.log('123')
    if (e.deltaY !== 0) {
      e.preventDefault()
      this.scrollLeft += e.deltaY
    }
  })
}

export function xorDecrypt(encryptedBase64, key) {
  let encryptedBytes = atob(encryptedBase64)

  let output = ''
  for (let i = 0; i < encryptedBytes.length; i++) {
    output += String.fromCharCode(encryptedBytes.charCodeAt(i) ^ key.charCodeAt(i % key.length))
  }

  return output
}
